import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Linking,
} from "react-native";
import AppImages from "../../../../Constants/AppImages";
import AppFonts from "../../../../Constants/AppFonts";
import AppColors from "../../../../Constants/AppColors";
// import { useTranslation } from "react-i18next";
// import Clipboard from "@react-native-community/clipboard";
import Appstyles from "../../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");
const AllVehicleCategory = ({ navigation }) => {
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const [DotModal, setDotModal] = useState(false);
  const [select, setSelected] = useState(0);

  const handlePress = () => {
    setSelected(!select);
  };
  const [Modalvisible1, setModalvisible1] = useState(false);

  const [selectedButton, setSelectedButton] = useState(null);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };

  //------------share
  const [DotModalshare, setDotModalshare] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const handleTextPress = (index) => {
    setActiveIndex(index);
  };

  const [linkText, setLinkText] = useState(
    "https://Vehicletrackingsystem.com/12345"
  );
  const [isCopied, setIsCopied] = useState(false);

  // const copyLink = async () => {
  //   try {
  //     await Clipboard.setString(linkText);
  //     setIsCopied(true);
  //     Alert.alert("Link Copied", "The link has been copied to the clipboard.");
  //   } catch (error) {
  //     console.error("Failed to copy link:", error);
  //     Alert.alert("Copy Failed", "An error occurred while copying the link.");
  //   }
  // };
  const shareEmail = () => {
    const emailUrl = `mailto:?subject=${encodeURIComponent(
      "Check out this link"
    )}&body=${encodeURIComponent(linkText)}`;
    Linking.openURL(emailUrl)
      .then(() => {
        console.log("Email app opened");
      })
      .catch((error) => {
        console.error("Failed to open email app:", error);
      });
  };

  const shareWhatsApp = () => {
    const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(linkText)}`;
    Linking.openURL(whatsappUrl)
      .then(() => {
        console.log("WhatsApp app opened");
      })
      .catch((error) => {
        console.error("Failed to open WhatsApp app:", error);
      });
  };

  const shareSMS = () => {
    const smsUrl = `sms:?body=${encodeURIComponent(linkText)}`;
    Linking.openURL(smsUrl)
      .then(() => {
        console.log("SMS app opened");
      })
      .catch((error) => {
        console.error("Failed to open SMS app:", error);
      });
  };

  //----------search -------del
  const AllCategory = [
    {
      id: 1,
      img: AppImages.LuxuryCar,
      Sixteen: AppImages.Sixteen,
      Name: "Luxury Car",
      Km: "2.5K",
      Count: "60",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
      Navi: "VehicleCategoryDetail",
    },
    {
      id: 2,
      Count: "60",
      img: AppImages.LuxuryBikes,
      Sixteen: AppImages.Sixteen,
      Name: "Bike",
      Km: "2.5K",
      Navi: "VehicleCategoryDetail",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    },
    {
      id: 3,
      Count: "60",
      img: AppImages.LuxuryCar,
      Sixteen: AppImages.Sixteen,
      Name: "Luxury Car",
      Km: "2.5K",
      Navi: "VehicleCategoryDetail",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    },
    {
      id: 4,
      Count: "60",
      img: AppImages.LuxuryBikes,
      Sixteen: AppImages.Sixteen,
      Name: "Bike",
      Km: "2.5K",
      Navi: "VehicleCategoryDetail",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    },
    {
      id: 5,
      Count: "60",
      img: AppImages.LuxuryCar,
      Sixteen: AppImages.Sixteen,
      Name: "Luxury Car",
      Km: "2.5K",
      Navi: "VehicleCategoryDetail",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    },
    {
      id: 6,
      Count: "60",
      img: AppImages.LuxuryBikes,
      Sixteen: AppImages.Sixteen,
      Name: "Bike",
      Km: "2.5K",
      Navi: "VehicleCategoryDetail",
      Repair: "2.5K",
      Fuel: "25$/ltr",
      Seating: "5",
      Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    },
  ];
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(AllCategory);
  const [searchText, setSearchText] = useState(""); // State for search input

  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = AllCategory.filter((item) =>
      item.Name.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  return (
    <SafeAreaView style={Appstyles.safe7}>
      <View style={Appstyles.SecMainnn7}>
        <View style={Appstyles.margintopbottom}>
          <View style={Appstyles.cateee7}>
            <View style={Appstyles.Searchvi6}>
              <TextInput
                style={Appstyles.TextInput7}
                placeholder={t("common:translation.Search Vehicle....")}
                placeholderTextColor={AppColors.grey1}
                editable={true}
                value={searchText} // Bind search input value to state
                onChangeText={handleSearch}
              />

              <View style={Appstyles.SearchImageView}>
                <Image
                  source={AppImages.search}
                  style={Appstyles.SearchImage}
                />
              </View>
            </View>

            <Image
              source={AppImages.Import}
              style={Appstyles.ImpoShare7}
              resizeMode="contain"
            />

            <TouchableOpacity onPress={() => setDotModalshare(true)}>
              <Image
                source={AppImages.Shareit}
                style={Appstyles.ImpoShare7}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <FlatList
        showsVerticalScrollIndicator={false}
        ListFooterComponent={() => <View style={{ padding: 0 }} />}
        data={data}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.fla}
            onPress={() => navigation.navigate(item.Navi)}
          >
            <View style={styles.mar}>
              <View style={styles.fld}>
                <View style={styles.mainh}>
                  <Image
                    source={item.img}
                    style={styles.lux}
                    resizeMode="contain"
                  />
                </View>
                <View style={styles.gag}>
                  <View style={styles.fldlj}>
                    <Text style={styles.trxt}>{item.Name}</Text>
                    <View
                      style={{
                        borderRadius: 60,
                        backgroundColor: AppColors.brown,
                        width: 30,
                        height: 30,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.white,
                          fontFamily: AppFonts.OverpassMedium,
                          fontSize: 12,
                          alignItems: "center",
                        }}
                      >
                        {item.Count}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.vcg}>
                    <View style={styles.wdw}>
                      <Image
                        source={AppImages.Kilometer}
                        style={styles.efd}
                        resizeMode="contain"
                      />
                      <Text style={styles.sdda}>{item.Km}</Text>
                    </View>
                    <Image
                      source={AppImages.RepairCar}
                      style={styles.qww}
                      resizeMode="contain"
                    />
                    <Text style={styles.ddsa}>{item.Repair}</Text>
                  </View>
                  <View style={styles.wdws}>
                    <View style={styles.wdw}>
                      <Image
                        source={AppImages.FuelTank}
                        style={styles.Fuel}
                        resizeMode="contain"
                      />
                      <Text style={styles.sdd}>{item.Fuel}</Text>
                    </View>
                    <Image
                      source={AppImages.SeatingCapacity}
                      style={styles.qww}
                      resizeMode="contain"
                    />
                    <Text style={styles.ddsa}>{item.Seating}</Text>
                  </View>
                  <Text style={styles.wwdwdc}>
                    {t("common:translation.Vehicle Description")}
                  </Text>
                  <Text style={styles.textdes}>{item.Des}</Text>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        )}
      />
      {/*  //----------------Share */}
      <Modal
        animationType="slide"
        visible={DotModalshare}
        onRequestClose={() => {
          setDotModalshare(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModalshare(false)}>
          <View
            style={{ backgroundColor: AppColors.ModalColor, flex: 1 }}
          ></View>
        </TouchableWithoutFeedback>
        <View
          style={{
            width: "100%",
            backgroundColor: "white",

            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
            position: "absolute",
            bottom: 0,
            paddingVrtical: 20,
          }}
        >
          <TouchableOpacity
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Image
              source={AppImages.LineBar}
              style={{ width: 40, height: 2.5, marginTop: 20 }}
            />
          </TouchableOpacity>
          <View
            style={{ borderBottomWidth: 1, borderBottomColor: "#9C49001A" }}
          >
            <Text
              style={[
                styles.activeText,
                {
                  marginTop: 20,
                  marginBottom: 10,
                  fontFamily: AppFonts.OverpassBold,
                  fontSize: 18,
                  color: AppColors.brown,
                },
              ]}
            >
              {t("common:translation.Share Vehicle Details")}
            </Text>
          </View>
          <TouchableWithoutFeedback onPress={() => handleTextPress(0)}>
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                  //   flexDirection:"row"
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 0 && styles.activeText]}
              >
                {t("common:translation.Link to share")}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback>
            <TouchableOpacity
              onPress={() => setDotModalshare(false)}
              style={{
                backgroundColor: AppColors.sandal,
                height: 40,
                // alignItems:"center",
                justifyContent: "center",
                marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 10,
                marginVertical: 12,
              }}
            >
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.brown1,
                  },
                ]}
              >
                {linkText}
              </Text>
            </TouchableOpacity>
          </TouchableWithoutFeedback>
          <View
            style={{
              backgroundColor: AppColors.brown,
              height: 40,
              alignItems: "center",
              justifyContent: "center",
              marginHorizontal: 20,
              paddingHorizontal: 10,
              borderRadius: 10,
              // marginVertical: 10,
              flexDirection: "row",
              alignSelf: "flex-end",
            }}
          >
            <Image
              source={AppImages.CopyLink}
              style={{ width: 24, height: 24, resizeMode: "contain" }}
            />
            <TouchableOpacity
            // onPress={() => [
            //   Clipboard.setString(
            //     '"https://Vehicletrackingsystem.com/12345"'
            //   ),
            //   setDotModalshare(false),
            // ]}
            >
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.white,
                    marginLeft: 12,
                  },
                ]}
              >
                {isCopied ? "Link Copied!" : "Copy Link"}
                {/* {t("common:translation.Copy Link")} */}
              </Text>
            </TouchableOpacity>
          </View>

          <TouchableWithoutFeedback>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginVertical: 10,
                marginHorizontal: 20,
              }}
            >
              <View
                style={{
                  flex: 1,
                  height: 1,
                  backgroundColor: AppColors.sandal,
                }}
              />
              <Text
                style={{
                  marginHorizontal: 10,

                  fontSize: 10,
                  fontFamily: AppFonts.OverpassRegular,
                  color: AppColors.dualbrown,
                }}
              >
                OR
              </Text>
              <View
                style={{
                  flex: 1,
                  height: 1,
                  backgroundColor: AppColors.sandal,
                }}
              />
            </View>
          </TouchableWithoutFeedback>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 20,
              marginHorizontal: 20,
              justifyContent: "space-between",
            }}
          >
            <TouchableOpacity
              onPress={shareEmail}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                elevation: 5,
                shadowColor: AppColors.brown,
                // width: "28%",
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.EmailShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.Email")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={shareSMS}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                //  width: "25%",
                elevation: 5,
                shadowColor: AppColors.brown,
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.SmsShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.SMS")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={shareWhatsApp}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                elevation: 5,
                shadowColor: AppColors.brown,
                //  width: "25%",
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.WhatsappShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.WhatsApp")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default AllVehicleCategory;
const styles = StyleSheet.create({
  ha: { width: 22, height: 22 },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
    marginLeft: 20,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
    marginLeft: 20,
  },
  MainView: { backgroundColor: AppColors.white, flex: 1 },
  SecMain: { marginHorizontal: 20, backgroundColor: AppColors.white },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 20,
    width: "100%",
    // height: height * 0.07,
    paddingVertical: 10,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    paddingLeft: 20,
    borderWidth: 1,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  impo: { width: 22, height: 22 },
  sha: { width: 22, height: 22, marginLeft: 10 },
  fla: {
    // marginTop: 20,
    marginBottom: 20,
    marginHorizontal: 20,
    borderRadius: 10,
    backgroundColor: AppColors.sandal,
    paddingVertical: 20,
  },
  mar: {},
  fld: {
    flexDirection: "row",
    // backgroundColor:'green',
  },
  mainh: {
    width: "40%",
    // height:'110%',
    // backgroundColor:'aqua',
    // marginRight:20,

    justifyContent: "center",

    alignItems: "center",
    borderRightWidth: 0.5,
    borderColor: AppColors.grey,

    // paddingVertical: 20
  },
  lux: { width: 82, height: 160 },
  gag: {
    marginLeft: 20,
    flex: 1,
    marginHorizontal: 20,
  },
  fldlj: {
    flexDirection: "row",
    justifyContent: "space-between",

    alignItems: "center",
  },
  trxt: {
    fontSize: 18,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown,
  },
  six: { width: 33, height: 33, alignItems: "center" },
  vcg: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 20,
  },
  wdw: {
    flexDirection: "row",
    width: "50%",
    alignItems: "center",
  },
  efd: { width: 26, height: 26, alignItems: "center" },
  sdda: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.darkbrown,
    fontWeight: "600",
    marginLeft: 5,
  },
  ddsa: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.darkbrown,
    fontWeight: "600",
    marginLeft: 5,
    alignItems: "center",
  },
  qww: { width: 26, height: 26, alignItems: "center" },
  wdws: {
    flexDirection: "row",
    marginTop: 15,
    alignItems: "center",
  },
  Fuel: { width: 26, height: 26 },

  sdd: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.darkbrown,

    marginLeft: 5,
    width: "50%",
  },
  wwdwdc: {
    fontSize: 12,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,

    marginLeft: 5,
    marginTop: 20,
  },
  textdes: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,

    marginLeft: 5,
    marginTop: 5,
  },
  dfdfdscd: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 12,
    color: AppColors.grey,
  },
});
